(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["convertx-before-after"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

    const setupComparison = (root) => {
      const comparison = root.querySelector('.convertx-before-after__comparison');
      const divider = root.querySelector('.convertx-before-after__comparison-divider');
      if (!comparison || !divider) return;

      const defaultPosition = Number(comparison.dataset.defaultPosition) || 50;
      let isDragging = false;

      const setPosition = (value) => {
        const safePosition = clamp(value, 0, 100);
        comparison.style.setProperty('--convertx-before-after-position', `${safePosition}%`);
      };

      const getPositionFromClientX = (clientX) => {
        const rect = comparison.getBoundingClientRect();
        if (!rect.width) return null;
        const rawPosition = ((clientX - rect.left) / rect.width) * 100;
        return clamp(rawPosition, 0, 100);
      };

      setPosition(defaultPosition);

      const moveFromEvent = (event) => {
        const position = getPositionFromClientX(event.clientX);
        if (position == null) return;
        setPosition(position);
      };

      divider.addEventListener('pointerdown', (event) => {
        isDragging = true;
        divider.setPointerCapture(event.pointerId);
        moveFromEvent(event);
      });

      divider.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        moveFromEvent(event);
      });

      const stopDragging = () => {
        isDragging = false;
      };

      divider.addEventListener('pointerup', stopDragging);
      divider.addEventListener('pointercancel', stopDragging);
      divider.addEventListener('lostpointercapture', stopDragging);

      comparison.addEventListener('click', (event) => {
        if (event.target.closest('.convertx-before-after__comparison-divider')) return;
        moveFromEvent(event);
      });
    };

    document.querySelectorAll('.convertx-before-after').forEach(setupComparison);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
